import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export default function AdMostUi ({value}) {

    const { t } = useTranslation();
    const nav = useNavigate();

    const handleNav = (id) => {
        nav(`ads?id=${id}`);
    };
    
    return(<>

            {/* Section 1: Most Liked Ads */}
            <div className='bg-thirdly rounded-lg p-5'>
                <label className='text-white pb-8 font-semiblod text-xl text-right'>{t("charts.most_liked_ads")}</label>
                <div className='flex sm:flex-row flex-col  sm:justify-between sm:items-center gap-8 mt-8 mb-4 px-4'>

                    {value?.most_liked_ads?.map((item) => (
                        <div key={item.id} onClick={()=> handleNav(item.id)} className='flex sm:flex-row flex-col justify-center items-center sm:justify-between sm:items-start cursor-pointer'>
                            <img src={item.main_photo} className='w-14 h-14 rounded-lg' alt={item.title} />
                            <div className='sm:ms-4  mt-1'>
                                <h2 className='text-white text-bold text-md'>{item.title}</h2>
                                <p className='text-white text-bold text-sm mt-2'>{item.description}</p>
                            </div>
                        </div>
                    ))}

                </div>
            </div>

            {/* Section 2: Most Viewed Ads */}
            <div className='bg-thirdly rounded-lg p-5 mt-5'>
                <label className='text-white pb-8 font-semiblod text-xl text-right'>{t("charts.most_watched_ads")}</label>
                <div className='flex sm:flex-row flex-col  sm:justify-between sm:items-center gap-8 px-4 mt-8 mb-4'>

                    {value?.most_viewed_ads?.map((item) => (
                        <div key={item.id} onClick={()=> handleNav(item.id)} className='flex sm:flex-row flex-col justify-center items-center sm:justify-between sm:items-start cursor-pointer'>
                            <img src={item.main_photo} className='w-14 h-14 rounded-lg' alt={item.title} />
                            <div className='sm:ms-4 mt-1'>
                                <h2 className='text-white text-bold text-md'>{item.title}</h2>
                                <p className='text-white text-bold text-sm mt-2'>{item.description}</p>
                            </div>
                        </div>
                    ))}

                </div>
            </div>  
    </>);
};